module.exports = __webpack_public_path__ + "static/media/Glass-of-Learning-Logo-Main.6973f64f.jpg";